import AutoPagination from '@/components/bs-ui/pagination/autoPagination'
/**
 * 表格底部分页区域
 *
 * Props:
 * - name: 左侧说明文案
 * - page: 当前页
 * - pageSize: 每页数量
 * - total: 总条数
 * - setPage: 页码切换回调
 */
const FouterPage = ({ page, pageSize, total, setPage, name = '', ...props }) => {
  return (
    <div className="bisheng-table-footer page_footer_zIndex px-6" style={{ background: '#F5F7FB' }} {...props}>
      <p className="break-keep text-sm text-muted-foreground">{name}</p>
      <AutoPagination
        className="m-0 w-auto justify-end"
        page={page}
        pageSize={pageSize}
        total={total}
        onChange={setPage}
      ></AutoPagination>
    </div>
  )
}
export default FouterPage
